import React, { Component } from 'react'
import { StaticBox, FlowTable, Modal, ProgressBar } from 'components/basic'
import { connect } from 'react-redux'
import http from 'API/http'
import { Installation } from 'config'
import { math, notify, host } from 'helpers'
import axios from 'axios'

class FileWidget extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      files: [],
      version: ''
    }
  }
  componentDidMount () {
    console.log("YYAYAYAYYAYAYAYYAY");
    this.getFiles(this.props.id, this.props.namespace, this.props.version)
    this.setState({version: this.props.version})
  }
  componentWillReceiveProps (props) {
    if (props.id === this.props.id) return
    this.getFiles(props.id, props.namespace, props.version)
    this.setState({version: props.version})
  }
  async getFiles (id, namespace, version) {
    this.setState({loading: true})
    var [err, res] = await http.get((typeof version !== 'undefined' ?  version  : '') + 'storage/' + id)
    if (err) return this.setState({error: true, loading: false})
    this.setState({loading: false, files: res.data, id: id, namespace: namespace})
  }
  async upload () {
    var data = new window.FormData()
    if (this.props.id) data.append('object_id', this.props.id)
    if (this.props.namespace) data.append('namespace', this.props.namespace)
    data.append('file', this.state.file)
    var config = {
      onUploadProgress: function (progressEvent) {
        this.setState({ progress: Math.round((progressEvent.loaded * 100) / progressEvent.total) })
      }.bind(this)
    }
    var [err, res] = await http.post((typeof this.state.version !== 'undefined' ?  this.state.version  : '') + 'storage/upload', data)
    if (err) return notify.warn('Unable to upload file')
    this.setState({ status: 'File uploaded' })
    notify.success('File uploaded')
    this.getFiles(this.props.id, this.props.namespace, this.props.version)
    this.resetUpload()
  }
  selectFile () {
    document.querySelector('#file-upload').click()
  }

  processFile () {
    var file = document.querySelector('#file-upload').files[0]
    this.setState({ filename: file.name, file: file })
  }
  resetUpload () {
    this.setState({
      progress: 0,
      status: 'Waiting for file',
      modal: false,
      file: null,
      filename: null
    })
    document.querySelector('#file-upload').value = ''
  }
  render () {
    if (!Installation.flow_url) return false
    return (
      <StaticBox title='Files' icon='file' buttons={[
        { icon: 'fa-upload', event: () => this.setState({modal: true}), datatip: 'Upload file' }
      ]}>
      <FlowTable loading={this.state.loading} data={this.state.files.map(file => [
        <a target='_blank' className='table-link' href={Installation.api_base + (typeof this.state.version !== 'undefined' ?  this.state.version : '') + 'storage/download/' + file.storageFile_id}><i className='fa fa-download' /></a>,
        file.name,
        math.size(file.size)
      ])} filter={this.state.filter}>
        <tr>
          <th className='buttons' />
          <th>Name</th>
          <th>Size</th>
        </tr>
      </FlowTable>

      <Modal close={() => this.resetUpload()} isOpen={this.state.modal} title={this.state.filename || 'Pick a file'}
        buttons={[
          { text: 'Select file', event: () => this.selectFile(), hidden: this.state.file },
          { text: 'Cancel', hidden: !this.state.file, event: () => this.resetUpload() },
          { text: 'Upload', hidden: !this.state.file, event: () => this.upload() } ]}>
        <small>{this.state.status}</small>
        <ProgressBar percentage={this.state.progress} />
        <input id='file-upload' type='file' className='hidden' onChange={() => this.processFile()} />
      </Modal>
      </StaticBox>
    )
  }
}

export default FileWidget



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/core/FileWidget.js